import { request } from "../../../Services/Api"

export const getRequestsEnrollmentsFilterOptions = () =>
  request.api.get("/user/requests/enrollments/filter_options/")
export const getEnrollmentsRequests = (params) =>
  request.api.get(`/user/requests/enrollments/`, params)
export const updateEnrollmentRequests = ({ id, ...params }) =>
  request.api.patch(`/user/requests/enrollments/${id}/`, params)
export const deleteEnrollmentRequests = (id) =>
  request.api.delete(`/user/requests/enrollments/${id}/`)
export const getRequestsEnrollmentsExport = ({ file_name, ...params }) =>
  request.api.get(`/user/requests/enrollments/export_enrollments_request_data/`, params)
